var path = '/templates/projects.segments/campaign_segment_edit_all.html';
var html = "<section class=form-horizontal></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.segments/campaign_segment_edit_all.html
// module id = 1478
// module chunks = 0